import Highlighter from 'react-highlight-words';
import PropTypes from 'prop-types';
import React from 'react';

const ResultTerm = ({ term, index, itemProps, isHighlighted, inputValue }) => {
	return (
		<li
			data-testid={`siteSearch-term-${index}`}
			className={`siteSearch__term px-4 hover:px-4 ${
				isHighlighted ? 'siteSearch__term--is-highlighted' : ''
			} needsclick`}
			{...itemProps}>
			<Highlighter
				highlightClassName="siteSearch__highlighted-text"
				searchWords={[inputValue]}
				autoEscape={true}
				highlightTag="strong"
				textToHighlight={term}
				data-testid="siteSearch-highlighted-text"
			/>
		</li>
	);
};

ResultTerm.propTypes = {
	term: PropTypes.string,
	index: PropTypes.any,
	itemProps: PropTypes.object,
	isHighlighted: PropTypes.bool,
	inputValue: PropTypes.string,
};

export default ResultTerm;
